import KrButton from "./src/button";
import KrCard from "./src/card";
import KrCascade from "./src/kr-cascade";
import KrCes from "./src/kr-ces";
import KrCsat from "./src/kr-csat";
import KrDate from "./src/kr-date";
import KrEvaluation from "./src/kr-evaluation";
import KrFileUpload from "./src/kr-file-upload";
import KrFillBlank from "./src/kr-fill-blank";
import KrLocation from "./src/kr-location";
import KrMultipleChoice from "./src/kr-multiple-choice";
import KrNps from "./src/kr-nps";
import KrPaging from "./src/kr-paging";
import KrRemark from "./src/kr-remark";
import KrScore from "./src/kr-score";
import KrSinggleChoice from "./src/kr-singgle-choice";
import KrSort from "./src/kr-sort";
import KrCity from "./src/kr-city";
// setting
import KrCesSetting from "./src/kr-ces-setting";
import KrCsatSetting from "./src/kr-csat-setting";
import KrDateSetting from "./src/kr-date-setting";
import KrEvaluationSetting from "./src/kr-evaluation-setting";
import KrFileUploadSetting from "./src/kr-file-upload-setting";
import KrLocationSetting from "./src/kr-location-setting";
import KrMultipleChoiceSetting from "./src/kr-multiple-choice-setting";
import KrNpsSetting from "./src/kr-nps-setting";
import KrPagingSetting from "./src/kr-paging-setting";
import KrScoreSetting from "./src/kr-score-setting";
import KrSinggleChoiceSetting from "./src/kr-singgle-choice-setting";
import KrFillBlankSetting from "./src/kr-fill-blank-setting";
import KrSortSetting from "./src/kr-sort-setting";
import KrCitySetting from "./src/kr-city-setting";

import SvgIcon from "./components/svgIcon/Index.vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

import "virtual:svg-icons-register";

// 导出单个组件
export {
    KrButton,
    KrCard,
    KrCascade,
    KrCes,
    KrCsat,
    KrDate,
    KrEvaluation,
    KrFileUpload,
    KrFillBlank,
    KrLocation,
    KrMultipleChoice,
    KrNps,
    KrPaging,
    KrRemark,
    KrScore,
    KrSinggleChoice,
    KrSort,
    KrCity,
    KrCesSetting,
    KrCsatSetting,
    KrDateSetting,
    KrEvaluationSetting,
    KrFileUploadSetting,
    KrLocationSetting,
    KrMultipleChoiceSetting,
    KrNpsSetting,
    KrPagingSetting,
    KrScoreSetting,
    KrSinggleChoiceSetting,
    KrSortSetting,
    KrFillBlankSetting,
    KrCitySetting,
};

// 导出所有组件
export default {
    install(app) {
        app.use(ElementPlus);
        app.component(SvgIcon.name, SvgIcon);
        app.component(KrButton.name, KrButton);
        app.component(KrCard.name, KrCard);
        app.component(KrCascade.name, KrCascade);
        app.component(KrCes.name, KrCes);
        app.component(KrCsat.name, KrCsat);
        app.component(KrDate.name, KrDate);
        app.component(KrEvaluation.name, KrEvaluation);
        app.component(KrFileUpload.name, KrFileUpload);
        app.component(KrFillBlank.name, KrFillBlank);
        app.component(KrLocation.name, KrLocation);
        app.component(KrMultipleChoice.name, KrMultipleChoice);
        app.component(KrNps.name, KrNps);
        app.component(KrPaging.name, KrPaging);
        app.component(KrRemark.name, KrRemark);
        app.component(KrScore.name, KrScore);
        app.component(KrSinggleChoice.name, KrSinggleChoice);
        app.component(KrSort.name, KrSort);
        app.component(KrCity.name, KrCity);
        app.component(KrCesSetting.name, KrCesSetting);
        app.component(KrCsatSetting.name, KrCsatSetting);
        app.component(KrDateSetting.name, KrDateSetting);
        app.component(KrEvaluationSetting.name, KrEvaluationSetting);
        app.component(KrFileUploadSetting.name, KrFileUploadSetting);
        app.component(KrLocationSetting.name, KrLocationSetting);
        app.component(KrMultipleChoiceSetting.name, KrMultipleChoiceSetting);
        app.component(KrNpsSetting.name, KrNpsSetting);
        app.component(KrPagingSetting.name, KrPagingSetting);
        app.component(KrScoreSetting.name, KrScoreSetting);
        app.component(KrSinggleChoiceSetting.name, KrSinggleChoiceSetting);
        app.component(KrSortSetting.name, KrSortSetting);
        app.component(KrFillBlankSetting.name, KrFillBlankSetting);
        app.component(KrCitySetting.name, KrCitySetting);
    },
};
